import { Link } from 'react-router-dom';
import { useT } from '@/i18n';
import { AppShell } from '@/components/layout';
import { FAQ_GROUPS } from '@/content/faq';
import { FaqList } from '@/features/faq/FaqList';
import { COMPANY } from '@/content/company';

/** Every question, grouped. Its FAQPage structured data comes from src/seo, like every page's. */
export const Faq = () => {
  const t = useT();

  return (
    <AppShell>
      <div className="grid gap-10 nav:grid-cols-[280px_minmax(0,1fr)] nav:gap-14">
        <div className="nav:sticky nav:top-24 nav:self-start">
          <p className="eyebrow text-lagoon-600">{t('landing.faq')}</p>
          <h1 className="mt-2 text-display">{t('faq.title')}</h1>
          <p className="mt-3 text-body text-ink-soft">{t('l2.faqIntro')}</p>
          <nav aria-label={t('legal.contents')} className="mt-6 grid gap-1 text-label">
            {FAQ_GROUPS.map((g) => (
              <a key={g.id} href={`#group-${g.id}`} className="min-h-[36px] py-1 text-lagoon-700 hover:underline">
                {t(`faq.group.${g.id}`)}
              </a>
            ))}
          </nav>
          <p className="mt-6 text-caption text-ink-muted">
            {t('faq.still')}{' '}
            <a href={`mailto:${COMPANY.supportEmail}`} className="font-bold text-lagoon-700 hover:underline">
              {COMPANY.supportEmail}
            </a>
          </p>
        </div>
        <div className="grid gap-12">
          {FAQ_GROUPS.map((g) => (
            <section key={g.id} id={`group-${g.id}`} aria-labelledby={`group-${g.id}-h`} className="scroll-mt-24">
              <h2 id={`group-${g.id}-h`} className="mb-3 text-h2">
                {t(`faq.group.${g.id}`)}
              </h2>
              <FaqList ids={g.items} />
            </section>
          ))}
          <p className="text-body text-ink-soft">
            {t('faq.learnMore')}{' '}
            <Link to="/learn" className="font-bold text-lagoon-700 hover:underline">
              {t('nav.learn')} →
            </Link>
          </p>
        </div>
      </div>
    </AppShell>
  );
};

export default Faq;
